/** @jsxImportSource @emotion/react */

import { FC } from "react";
import HR from "../HorizontalLine";
import Row from "../Grid/Row";
import Column from "../Grid/Column";
import { ColorNames } from "../../theme";
import Typography from "../Typography";
import { TModelFilter } from "../../hooks/useModelFilter";
import MultiSelectInput from "../Input/SelectInputs/MultiSelectInput";
import SearchBar from "../SearchBar";
import Many2ManyInput from "../Input/SelectInputs/Many2ManyInput";

const marginBottom = 24;
const horizontalLineHeight = 2;
const filterHeight = 110;

export const totalFilterHeight =
  filterHeight + marginBottom + horizontalLineHeight * 2;
interface FilterMenuProps {
  filter: TModelFilter;
}

const FilterMenu: FC<FilterMenuProps> = ({ filter }) => {
  const { filters, setFilterValue } = filter;

  return (
    <div
      css={{ marginBottom: marginBottom, zIndex: 100, position: "relative" }}
    >
      <HR
        color={ColorNames.GREY}
        spacingSize="none"
        borderWidth={horizontalLineHeight}
      />
      <Row css={{ margin: 0, height: filterHeight }}>
        <Column xs={12} lg={12}>
          <Row css={{ margin: 0, height: "100%" }} align="center">
            {filters.map((filter) => (
              <Column xs={12} lg={2.5} key={filter.name}>
                <Row css={{ margin: 0, height: "100%" }} align="center">
                  <Column xs={5} xl={4}>
                    <Typography
                      variant="textMedium"
                      color="Black"
                      uppercase
                      weight="bold"
                      component="div"
                      align="left"
                    >
                      {filter.label}
                    </Typography>
                  </Column>
                  <Column xs={7} xl={8}>
                    {!filter.many2Many && (
                      <MultiSelectInput
                        options={filter.options}
                        inputName={filter.name}
                        onSelect={(value) => setFilterValue(filter.name, value)}
                        value={filter.value}
                        hideDropdown
                        multiValueDisplay={filter.selectMultiValueDisplay}
                        menuListDisplay={filter.selectMenuListDisplay}
                        optionDisplay={filter.selectOptionDisplay}
                        placeholder="Todos"
                      />
                    )}
                    {filter.many2Many && (
                      <Many2ManyInput
                        serviceName={filter.many2Many?.serviceName}
                        domain={filter.many2Many?.domain}
                        inputName={filter.name}
                        onSelect={(value) => setFilterValue(filter.name, value)}
                        value={filter.value}
                        hideDropdown
                        multiValueDisplay={filter.selectMultiValueDisplay}
                        menuListDisplay={filter.selectMenuListDisplay}
                        optionDisplay={filter.selectOptionDisplay}
                        placeholder="Todos"
                      />
                    )}
                  </Column>
                </Row>
              </Column>
            ))}

            <Column
              xs={12}
              lg={2}
              css={{
                display: "flex",
                alignItems: "end",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <div
                css={{
                  display: "flex",
                  alignItems: "center",

                  height: filters.length > 3 ? "50%" : "100%",
                  width: "80%",
                }}
              >
                <SearchBar filter={filter} />
              </div>
            </Column>
          </Row>
        </Column>
      </Row>
      <HR
        color={ColorNames.GREY}
        spacingSize="none"
        borderWidth={horizontalLineHeight}
      />
    </div>
  );
};

export default FilterMenu;
